const blockedTenantDialog = {
    title: 'This Tenant has been blocked',
    text: 'This Tenant has been discontinued or blocked, all features is disabled, if there are any question, please call support',
  }
  
  export default blockedTenantDialog;
  